import React, { Fragment, Component } from "react";
import Breadcrumb from "../components/common/breadcrumb";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./Dashboard.css";
import { change_Lang } from "../actions/Helper_action";
import { Modal, Button } from "antd";
import { Count_Agent_Actions } from "../actions_agent/Dashboard_action";
import { isMobile } from "react-device-detect";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";

class Agent_Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
      S_show: false,
      P_show: false,
    };
  }
  componentDidMount() {
    const { Count_Agent_Actions } = this.props;
    Count_Agent_Actions();
  }
  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = () => {
    this.setState({ show: true });
  };
  S_handleClose = () => {
    this.setState({ S_show: false });
  };
  S_handleShow = () => {
    this.setState({ S_show: true });
  };
  P_handleClose = () => {
    this.setState({ P_show: false });
  };
  P_handleShow = () => {
    this.setState({ P_show: true });
  };
  render() {
    const { change_Lang, lang, count_actions } = this.props;
    return (
      <>
        <Fragment>
          <Breadcrumb
            title={change_Lang("s_dashboard")}
            parent={change_Lang("s_dashboard")}
          />
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <>
              <div className="row">
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <div className="card o-hidden widget-cards cardss">
                    {isMobile !== true ? (
                      <div className=" card-body">
                        <Link to="/Secondary_Sell_Form">
                          {" "}
                          <div className="media static-top-widget row">
                            <div className="align-self-center text-center">
                              <button
                                className="btn py-2 px-3  btn-sm"
                                style={{
                                  background: "#295a68",
                                  borderRadius: "10px",
                                }}
                              >
                                <i
                                  className="fa-regular fa-handshake"
                                  style={{ fontSize: "24px", color: "#efefed" }}
                                ></i>
                              </button>
                            </div>
                            <div className="media-body col-8 text-center">
                              <span
                                className="m-0 fk"
                                style={{ fontSize: "16px", color: "black" }}
                              >
                                {change_Lang("Sell_Contracts")}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <Link to="/Secondary_Sell_Form">
                          {" "}
                          <div className="media static-top-widget row">
                            <div className="align-self-center text-center">
                              <button
                                className={
                                  lang === "en"
                                    ? "btn py-3 ml-4  btn-sm"
                                    : "btn py-3 mr-4  btn-sm"
                                }
                                style={{
                                  color: "white",
                                  background: "#ffd459",
                                  borderRadius: "10px",
                                }}
                              >
                                <i
                                  className="fa-regular fa-handshake"
                                  style={{ fontSize: "24px" }}
                                ></i>
                              </button>
                            </div>
                            <div className="media-body col-8">
                              <span
                                className="m-0 d-flex justify-content-center"
                                style={{ fontSize: "16px", color: "black" }}
                              >
                                {change_Lang("Sell_Contracts")}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                {isMobile !== true ? (
                  <div className="col-xl-3 col-md-6 xl-50 mb-3">
                    <Link to="/Secondary_Form">
                      <div className="card o-hidden widget-cards cardss">
                        <div className=" card-body">
                          <div className="media static-top-widget row">
                            <div className="align-self-center text-center">
                              <button
                                className="btn py-2 px-3  btn-sm"
                                style={{
                                  color: "#fff",
                                  background: "#295a68",
                                  borderRadius: "10px",
                                }}
                              >
                                <i
                                  className="fa-regular fa-paste"
                                  style={{ fontSize: "24px" }}
                                ></i>
                              </button>
                            </div>
                            <div className="media-body col-8 text-center">
                              <span
                                className="m-0 fk"
                                style={{ fontSize: "16px", color: "black" }}
                              >
                                {change_Lang("Rental contract")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ) : (
                  <div className="col-xl-3 col-md-6 xl-50 mb-3">
                    <Link to="/Secondary_Form">
                      <div className="card o-hidden widget-cards cardss">
                        <div
                          className=" card-body"
                          style={{ background: "#f6f8fa" }}
                        >
                          <div className="media static-top-widget row">
                            <div className="align-self-center text-center">
                              <button
                                className={
                                  lang === "en"
                                    ? "btn py-3 ml-4  btn-sm"
                                    : "btn py-3 mr-4  btn-sm"
                                }
                                style={{
                                  color: "white",
                                  background: "#7242e2",
                                  borderRadius: "10px",
                                }}
                              >
                                <i
                                  className="fa-regular fa-clipboard"
                                  style={{ fontSize: "24px" }}
                                ></i>
                              </button>
                            </div>
                            <div className="media-body col-8">
                              <span
                                className="m-0 d-flex justify-content-center"
                                style={{ fontSize: "16px", color: "black" }}
                              >
                                {change_Lang("Rental contract")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                )}
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <div className="card o-hidden widget-cards cardss">
                    {isMobile !== true ? (
                      <div className=" card-body">
                        <div
                          onClick={this.P_handleShow}
                          style={{ cursor: "pointer" }}
                          className="media static-top-widget row"
                        >
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#fff",
                                background: "#295a68",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-clipboard"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-12 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Bills")}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <div
                          onClick={this.P_handleShow}
                          style={{ cursor: "pointer" }}
                          className="media static-top-widget row"
                        >
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "white",
                                background: "#fb7d4d",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-file-lines"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-12">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Bills")}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <div className="card o-hidden widget-cards cardss">
                    {isMobile !== true ? (
                      <div
                        className=" card-body"
                        style={{ background: "#fff", cursor: "pointer" }}
                      >
                        <div
                          className="media static-top-widget row"
                          onClick={this.S_handleShow}
                        >
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#efefed",
                                background: "#295a68",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-file-lines"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Anket")}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <div
                          className="media static-top-widget row"
                          onClick={this.S_handleShow}
                        >
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "white",
                                background: "#46dbac",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-file-lines"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Anket")}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="container-fluid py-4">
                <div className="row">
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/list_Sell_Property">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fas fa-home mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.availablesale}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Sell List")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/list_Rent_Property">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape shadow-success text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fas fa-house-user mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.availablerent}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Rent List")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/required-products/sell-list">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape shadow-info text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fa-solid fa-hand-sparkles mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {" "}
                            {count_actions && count_actions.requirerd}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("add_Required")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to={`/List_customers_detail`}>
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-info shadow-info text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fa-solid fa-circle-info mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">##</h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Customer Detail")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/List_Sell_Invoices">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fas fa-handshake mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.sale}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bolder",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Contracts sold")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/List_Rent_Invoices">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fas fa-handshake mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.rent}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "bolder",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Rental Contracts")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/take_money_list">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-dark shadow-dark text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="far fa-file-alt mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.wasl}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0 "
                            style={{
                              fontWeight: "bolder",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Bills")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
                    <Link to="/Tenant_Lists">
                      <div className="card cardss">
                        <div
                          className={`${
                            lang === "en"
                              ? "card-header p-3 pt-2 d-flex justify-content-start"
                              : "card-header p-3 pt-2 d-flex justify-content-end"
                          }`}
                        >
                          <div
                            style={{ background: "#295a68" }}
                            className="icon icon-lg icon-shape bg-gradient-dark shadow-dark text-center border-radius-xl mt-n4 position-absolute"
                          >
                            <i
                              style={{ color: "#efefed" }}
                              className="fas fa-users mt-1"
                            ></i>
                          </div>
                        </div>
                        <div className="text-end  pr-3 mb-2 ">
                          <p className="text-sm mb-2 text-capitalize">
                            {change_Lang("Number")}
                          </p>
                          <h4 className="mb-0">
                            {count_actions && count_actions.tenant}
                          </h4>
                        </div>
                        <hr className="dark horizontal my-0 " />
                        <div className="card-footer p-3 d-flex justify-content-center">
                          <p
                            className="mb-0 "
                            style={{
                              fontWeight: "bolder",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            {change_Lang("Tenants_")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </>
          </div>
          {/* Bills*/}
          <Modal
            title={change_Lang(
              "Choose the type of payment or payment bill type"
            )}
            className="fk"
            style={{ fontSize: "10px" }}
            width={500}
            open={this.state.P_show}
            onCancel={this.P_handleClose}
            footer={false}
          >
            <div className="d-flex justify-content-center">
              <Link to="/take_money">
                <Button
                  className={`${lang === "en" ? "" : "fk"}`}
                  // type="primary"
                  style={{ background: "#295a68", color: "white" }}
                  onClick={this.P_handleClose}
                >
                  {change_Lang("Repayment")}
                </Button>
              </Link>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Link to="/pswlay_paradan">
                <Button
                  className={`${lang === "en" ? "" : "fk"}`}
                  style={{ background: "white", color: "#295a68" }}
                >
                  {change_Lang("Payment")}
                </Button>
              </Link>
            </div>
          </Modal>
          {/* Ankets*/}
          <Modal
            title={change_Lang("Sceurity Anket")}
            className="fk"
            style={{ fontSize: "10px" }}
            width={500}
            open={this.state.S_show}
            onCancel={this.S_handleClose}
            footer={false}
          >
            <div className="d-flex justify-content-center">
              <Link to="/pswlay_Asaysh">
                <Button
                  className={`${lang === "en" ? "" : "fk"}`}
                  style={{ background: "#295a68", color: "white" }}
                  onClick={this.S_handleClose}
                >
                  {change_Lang("Sceurity Anket")}
                </Button>
              </Link>
              {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Link to="/Customer_Anket">
                <Button
                  className={`${lang === "en" ? "" : "fk"}`}
                  style={{ background: "white", color: "#295a68" }}
                >
                  {change_Lang("Seller Anket")}
                </Button>
              </Link> */}
            </div>
          </Modal>
        </Fragment>
      </>
    );
  }
}

const MapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    count_actions: state.Dashboard_Reducer.count_actions,
  };
};

const MapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Count_Agent_Actions: () => dispatch(Count_Agent_Actions()),
  };
};
export default connect(MapStateToProps, MapDispatchToProps)(Agent_Dashboard);
